import Container from "../container";


class ExContainer extends Container{
	constructor(containerDocument, booksSetting) {
		super(containerDocument);
	}
}

export default ExContainer;